import {
  Dialog as DialogComponent,
  DialogContent as DialogContentComponent,
  DialogTitle as DialogTitleComponent,
} from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts, margins } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: scroll;

  .titlePage {
    font-size: 16px;
    color: ${colors.black};
    margin: ${margins.default}px;
    font-weight: 600;
  }
`;

export const TopButtons = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-right: ${margins.default}px;
  width: 80px;

  button {
    background-color: transparent!important;
    text-transform: none;
    padding: 0!important;
    width: auto!important;
    min-width: auto!important;
    font-size: ${fonts.default}px;
    font-weight: 800;
    color: ${colors.black}!important;
    opacity: 0.5;

    &:hover {
      background-color: transparent!important;
    }

    &:last-child {
      margin-left: 15px;
    }
  }

  .active {
    color: ${colors.lightBlue}!important;
    margin-left: 15px;
  }
`;

export const Content = lib.styled.div`
  display: flex;
  margin: 15px;
  margin-top: ${margins.reset}px;
  padding: 15px;
  flex-direction: column;
  overflow-x: scroll;
  background-color: ${colors.white02};
  border-radius: 10px;
  border: 1px dotted ${colors.lightGray06};
`;

export const BoxInput = lib.styled.div`
  height: 50px;
  margin-bottom: 7px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;

  .icon {
    margin-bottom: 2px;
    margin-right: 10px;
  }

  span {
    font-size: 10px;
  }

  .inputField {
    width: 100%;

    label {
      font-size: 12px;
    }

    input {
      font-size: ${fonts.default}px;
    }

    [class*='MuiInput-underline-'] {
      &:before, &:after {
        border-bottom: 0.5px solid ${colors.lightGray06};
      }

      &:hover {
        &:before, &:after {
          border-bottom: 0.5px solid ${colors.lightGray06};
        }
      }
    }
  }
`;

export const GroupBox = lib.styled.div`
  display: flex;
  flex-direction: row;

  div:first-child {
    margin-right: 5px
  }
`;

export const BoxSwitch = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  max-height: 20px;
  margin-top: ${margins.alternative}px;

  span {
    font-size: 12px;
  }
`;

export const Dialog = lib.styled(DialogComponent)`
  .MuiDialog-paper {
    margin: 0;
    padding-bottom: 0px;
  }
`;

export const DialogContent = lib.styled(DialogContentComponent)`
  display: flex;
  flex-direction: column;
  width: 320px;
  margin-top: 15px;
`;

export const DialogTitle = lib.styled(DialogTitleComponent)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  &.MuiDialogTitle-root {
    padding: 20px 15px 9px;
  }

  span {
    font-size: 16px;
    font-weight: 500;
  }
`;

export const ButtonStyled = lib.styled.button`
  display: flex;
  width: 85px;
  height: 26px;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  font-size: 14px;
  font-weight: 800;
  font-family: Nunito!important;
  color: #FFF;
  border-width: 0px;
  border-radius: 50px;
  cursor: pointer;
  background: linear-gradient(50.28deg,#67C2E4 2.79%,#0C4BBC 73.37%);
  margin: 10px 0 10px 0;
  &:focus {
    outline: 0;
  }

  .loader {
    color: ${colors.white}
  }
`;

export const PaperContent = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.lightGray15};
  min-height: 40px;
  gap: 5px;
  cursor: pointer;
  color: ${colors.lightBlue};
`;
